import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, AbstractControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContext, DwFormControl, DwFormControlInit, DwFormFieldConfig } from '@devwareapps/devware-cap';

@DwComponent({
  key: 'wachter-input-yesno-null',
  name: 'Yes/No (Nullable)',
  componentType: DwComponentType.formControl,
  isGlobal: true
})
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-wachter-input-yesno-null',
    template: `
    <div [formGroup]="formGroup">
        <dw-yesno [hidden]="fieldDef.isReadOnly" [formControlName]="fieldDef?.attrName" [attr.id]="fieldDef?.attrName || ''"></dw-yesno>
        <span [hidden]="!fieldDef.isReadOnly">
            <dw-readonly *ngIf="!isNull" [formControlName]="fieldDef?.attrName" formatType="yesno"></dw-readonly>
            <span *ngIf="isNull">Not Set</span>
        </span>
    </div>
  `,
})
export class WachterInputYesNoNullableComponent implements DwFormControl, DwFormControlInit {
    fieldDef: DwFormFieldConfig;
    formGroup: FormGroup;
    @Input() context : DwContext;

    isNull: boolean = false;
    initControl(): void {
        this.isNull = this.formGroup.get(this.fieldDef.attrName).value == null;
    }
}
